import type { ModuleLoader } from '@wix/thunderbolt-symbols'
import { BootstrapData } from '../../types'
import { IBuilderComponentSdkLoader } from '../types'
import { createSsrBuilderComponentSdkLoader } from './builderComponentSdkLoaders/ssrBuilderComponentSdkLoader'
import { createClientBuilderComponentSdkLoader } from './builderComponentSdkLoaders/clientBuilderComponentSdkLoader'
import { BOOTSTRAP_DATA, MODULE_LOADER, BUILDER_COMPONENT_SDK_LOADER } from './moduleNames'

const BuilderComponentSdkLoader = (bootstrapData: BootstrapData, moduleLoader: ModuleLoader): IBuilderComponentSdkLoader => {
	const { builderPublicPackagesUrls } = bootstrapData
	const isSSR = !process.env.browser

	return isSSR ? createSsrBuilderComponentSdkLoader(moduleLoader, builderPublicPackagesUrls) : createClientBuilderComponentSdkLoader()
}

export default {
	factory: BuilderComponentSdkLoader,
	deps: [BOOTSTRAP_DATA, MODULE_LOADER],
	name: BUILDER_COMPONENT_SDK_LOADER,
}
